var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCircleCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  stroke: "#4D4F5C",
  strokeWidth: 2,
  viewBox: "0 0 42 42"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 21,
  r: 20,
  stroke: "#D5D4DE"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M27.667 16 18.5 25.167 14.333 21"
})));
export { SvgCircleCheck as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0MiA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBzdHJva2U9IiM0RDRGNUMiIHN0cm9rZS13aWR0aD0iMiI+CjxjaXJjbGUgY3g9IjIxIiBjeT0iMjEiIHI9IjIwIiBzdHJva2U9IiNENUQ0REUiLz4KPHBhdGggZD0iTTI3LjY2NjcgMTZMMTguNSAyNS4xNjY3TDE0LjMzMzQgMjEiICBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";